import Button from 'antd/lib/button';
import message from 'antd/lib/message';
import FilePdfOutlined from '@ant-design/icons/FilePdfOutlined';
import CloudUploadOutlined from '@ant-design/icons/CloudUploadOutlined';
import React, { useState, useContext, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import { axiosGetCall, axiosPostCall } from '../../api/axiosCall';
import CommonLayout from '../../common/CommonLayout';
import { API_END_POINT, SOMETHING_WENT_WRONG } from '../../constant/constants';
import { AuthContext } from '../../context/AuthProvider';
import { uploadFile, S3ImageFolder } from '../../utils/imageUploader';

function Catalogue() {
  const [pdfFile, setPdfFile] = useState(null);
  const { token } = useContext(AuthContext);

  const [url, setUrl] = useState(null);

  useEffect(() => {
    getCatalogue();
  }, []);

  async function getCatalogue() {
    try {
      const res = await axiosGetCall({
        apiEndPoint: API_END_POINT.GET_CATALOGUE,
        header: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res?.hideErrorFromUser) {
        setUrl(res.data);
      } else {
        message.error(res?.error?.message);
      }
    } catch (error) {
      message.error(SOMETHING_WENT_WRONG);
    }
  }

  const onDrop = (acceptedFiles) => {
    if (acceptedFiles.length) {
      const file = acceptedFiles[0];
      setPdfFile(file);
    }
  };

  const handleSaveClick = async () => {
    try {
      const data = await uploadFile(pdfFile, S3ImageFolder.Catalogue, token);
      if (data) {
        const res = await axiosPostCall({
          apiEndPoint: API_END_POINT.ADD_CATALOGUE,
          header: {
            Authorization: `Bearer ${token}`,
          },
          body: {
            url: data,
          },
        });
        if (res?.hideErrorFromUser) {
          message.success(res.data);
          setPdfFile(null);
          getCatalogue();
        } else {
          message.error(res?.error?.message);
        }
      }
    } catch (error) {
      message.error(SOMETHING_WENT_WRONG);
    }
  };

  const handleCancelClick = () => {
    setPdfFile(null);
  };

  const handleFileInputChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setPdfFile(file);
    }
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: 'application/pdf',
  });

  return (
    <CommonLayout>
      <div className='flex flex-col items-center w-full p-6'>
        <div className='text-center mb-6'>
          <div className='inline-flex items-center gap-3'>
            <div className='p-2 rounded-lg shadow bg-gradient-to-r from-blue-500 to-purple-600'>
              <FilePdfOutlined className='text-white text-lg' />
            </div>
            <h1 className='text-2xl font-bold text-text m-0'>Catalogue</h1>
          </div>
          {url && (
            <div className='mt-2'>
              <a
                href={url}
                target='_blank'
                rel='noreferrer'
                className='text-primary underline'
              >
                View current catalogue
              </a>
            </div>
          )}
        </div>

        <div className='w-full max-w-xl bg-surface border border-border rounded-xl shadow p-6'>
          <div
            {...getRootProps()}
            className={`flex flex-col items-center justify-center p-6 border-2 border-dashed rounded-lg w-full h-40 mb-4 transition-colors ${
              isDragActive ? 'border-primary bg-bg' : 'border-border bg-white'
            } cursor-pointer`}
          >
            <input {...getInputProps()} />
            <CloudUploadOutlined className='text-2xl text-muted mb-2' />
            {isDragActive ? (
              <p className='text-text'>Drop the PDF here...</p>
            ) : (
              <p className='text-muted'>
                Drag & drop a PDF here, or click to select
              </p>
            )}
          </div>

          <input
            type='file'
            accept='application/pdf'
            onChange={handleFileInputChange}
            className='hidden'
            id='file-input'
          />
          <label
            htmlFor='file-input'
            className='inline-flex items-center gap-2 px-4 py-2 mt-2 rounded-lg bg-gradient-to-r from-blue-500 to-purple-600 text-white shadow cursor-pointer hover:shadow-md'
          >
            <FilePdfOutlined />
            Choose a PDF file
          </label>
          {pdfFile && (
            <p className='mt-4 text-text'>Uploaded file: {pdfFile.name}</p>
          )}

          <div className='flex justify-end gap-3 mt-6'>
            <Button
              onClick={() => handleCancelClick()}
              className='w-28 bg-surface border border-border text-text hover:text-primary hover:border-primary'
            >
              Cancel
            </Button>
            <Button
              onClick={() => handleSaveClick()}
              type='primary'
              className='w-36 border-none bg-gradient-to-r from-blue-500 to-purple-600 shadow hover:shadow-md'
              disabled={!pdfFile}
            >
              Save Catalogue
            </Button>
          </div>
        </div>
      </div>
    </CommonLayout>
  );
}

export default Catalogue;
